import { Box } from "@mui/material";
import React from "react";
import Styles from "./LoginMarquee.module.scss";
import Nlp from "../../../assets/images/banner/nationallogisticspolicy.png";
import DigiIndia from "../../../assets/images/banner/digitalindia.png";
import GatiShakti from "../../../assets/images/banner/gatishakti.png";
import MakeInIndia from "../../../assets/images/banner/makeinindia.png";
import StartupIndia from "../../../assets/images/banner/startupindia.png";
import Ulip from "../../../assets/images/banner/ulip.png";

function LoginMarquee() {
    let Icons = () => (<><Box
        sx={{
          height: "60px",
          width: "250px",
          flexShrink: 0,
          backgroundImage: `url(${Nlp})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          height: "60px",
          width: "180px",
          flexShrink: 0,
          backgroundImage: `url(${Ulip})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          height: "60px",
          width: "300px",
          flexShrink: 0,
          backgroundImage: `url(${DigiIndia})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          height: "60px",
          width: "200px",
          flexShrink: 0,
          backgroundImage: `url(${GatiShakti})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          height: "60px",
          width: "250px",
          flexShrink: 0,
          backgroundImage: `url(${MakeInIndia})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <Box
        sx={{
          height: "60px",
          width: "200px",
          flexShrink: 0,
          backgroundImage: `url(${StartupIndia})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      /></>);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        whiteSpace: "nowrap",
      }}
      className={Styles["moving"]}
      gap={"25px"}
    >
      <Icons/>
      <Icons/>
    </Box>
  );
}

export default LoginMarquee;
